import * as t from  './actionTypes';
import * as api from './api';

export function loadNewsletters() {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });

    api.getNewsletters((success, news, error) => {
      if (success) {
        dispatch({ type: t.NEWS_LOAD_SUCCESS, news: news });
        dispatch({ type: t.UNSET_BUSY });
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
      }
    });
  }
}

export function setNewsletters(news, successCB, errorCB) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });
    api.setNewsletters(news, function(success, news, error) {
      if (success) {
        dispatch({ type: t.NEWS_CHANGE_SUCCESS, news: news });
        dispatch({ type: t.UNSET_BUSY });
        successCB();
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
        errorCB();
      }
    });
  }
}
